/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse, makeMockResponse } from './mockUtils';
import { RequestToCreateExcelDto } from './downloadings/downloadingsClient.typings';

const DELAYED_EXCEL: RegExp = /\/(operators|companies|stores|cashboxes|documents|devices)\/excel$/;
const EXCEL_URL_PREFIX: RegExp = /\/excel$/;
const LOGS_ZIP: RegExp = /\/logs\/\d+/;

export function addExcelMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onPost(DELAYED_EXCEL).reply((config) => {
        const data: RequestToCreateExcelDto = {
            requestedDateAtUtc: '2023-02-02T10:27:11.996063',
            id: 678987,
            name: 'some s3 name',
            status: 'CREATED',
            type: 'OBJECTS',
        };
        return delayedResponse(makeMockResponse(200, data, config), 100);
    });

    mockAdapter.onGet(EXCEL_URL_PREFIX).reply((config) => {
        return delayedResponse(
            makeMockResponse(
                200,
                ['The application is running on mock data, this excel file is a simple plug (for GET endpoint).'],
                config,
            ),
            100,
        );
    });

    mockAdapter.onPost(EXCEL_URL_PREFIX).reply((config) => {
        return delayedResponse(
            makeMockResponse(
                200,
                ['The application is running on mock data, this excel file is a simple plug (for POST endpoint).'],
                config,
            ),
            100,
        );
    });

    mockAdapter.onGet(LOGS_ZIP).reply((config) => {
        return delayedResponse(
            makeMockResponse(200, ['The application is running on mock data, this zip file is a simple plug'], config),
            100,
        );
    });
}
